import React, { useEffect, useState } from 'react';
import { apiClient } from '../api/api';
import './CreatorPerformance.css';
import GradientHeading from './GradientHeading';
import Loader from './Loader';

const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return '-';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }).format(amount);
};

const formatPercent = (value) => {
  if (value === null || value === undefined || isNaN(value)) return '-';
  return value.toFixed(2) + '%';
};

const CreatorPerformance = () => {
  const [creators, setCreators] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const PAGE_SIZE = 10;

  useEffect(() => {
    const fetchCreators = async () => {
      setLoading(true);
      setError(null);
      try {
        const params = {
          page,
          page_size: PAGE_SIZE,
        };
        const response = await apiClient.get('/affiliate_creators', { params });
        setCreators(response.data.creators || []);
        setTotalCount(response.data.total_count || 0);
      } catch (err) {
        setError('Failed to load creator data.');
        console.error("Error fetching creators:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCreators();
  }, [page]);

  useEffect(() => {

      }, []);

  const handlePrev = () => setPage((p) => Math.max(1, p - 1));
  const handleNext = () => setPage((p) => (p * PAGE_SIZE < totalCount ? p + 1 : p));

  const handleViewVideos = (creatorId) => {
    // Handle viewing top videos for this creator
    console.log(`View top videos for creator ID: ${creatorId}`);
  };

  return (
    <div className="page-relative-wrapper">
      {loading && (
        <div className="page-overlay-loader">
          <Loader fullPage={false} text="Syncing Creator Data..." />
        </div>
      )}
      <div className={`creator-performance-container ${loading ? 'content-blur' : ''}`}>
      <GradientHeading>Creator Performance</GradientHeading>

      <div className="creator-performance-content">
        <div className="table-container">
          <table className="creators-table">
            <thead>
              <tr>
                <th>Creator Name</th>
                <th>Total GMV</th>
                <th>Total Orders</th>
                <th>Total Units Sold</th>
                <th>CTR</th>
                <th>Average Views</th>
                <th>Refund Rate</th>
                <th>AOV</th>
                <th>Top Videos</th>
              </tr>
            </thead>
            {error ? (
              <tbody>
                <tr><td colSpan={9} className="error"><i className="error-icon">⚠️</i> {error}</td></tr>
              </tbody>
            ) : (
              <tbody>
                {creators.length === 0 ? (
                  <tr><td colSpan={9} className="no-data">No creator data available</td></tr>
                ) : (
                  creators.map((creator) => (
                    <tr key={creator.id}>
                      <td className="creator-name">
                        <div className="creator-profile">
                          <img 
                            src={creator.profile_image || '/default-avatar.png'} 
                            alt={creator.name}
                            className="creator-avatar"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = '/default-avatar.png';
                            }}
                          />
                          <div className="creator-info">
                            <span className="name">{creator.name}</span>
                            <span className="username">@{creator.username}</span>
                          </div>
                        </div>
                      </td>
                      <td className="numeric highlight">{formatCurrency(creator.total_gmv)}</td>
                      <td className="numeric">{creator.total_orders || '-'}</td>
                      <td className="numeric">{creator.total_units_sold || '-'}</td>
                      <td className="numeric">{formatPercent(creator.ctr)}</td>
                      <td className="numeric">{creator.avg_views?.toLocaleString() || '-'}</td>
                      <td className="numeric">{formatPercent(creator.refund_rate)}</td>
                      <td className="numeric">{formatCurrency(creator.aov)}</td>
                      <td>
                        <button 
                          className="view-videos-btn"
                          onClick={() => handleViewVideos(creator.id)}
                          disabled={!creator.top_videos?.length}
                        >
                          View Videos
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            )}
          </table>
        </div>

        <div className="pagination-container">
          <button className="pagination-button" onClick={handlePrev} disabled={page === 1}>
            <span className="pagination-arrow">←</span> Previous
          </button>
          <div className="pagination-info">
            Page <span className="page-number">{page}</span> of <span className="page-number">{Math.ceil(totalCount / PAGE_SIZE) || 1}</span>
          </div>
          <button className="pagination-button" onClick={handleNext} disabled={page * PAGE_SIZE >= totalCount}>
            Next <span className="pagination-arrow">→</span>
          </button>
        </div>
      </div>
      </div>
    </div>
  );
};

export default CreatorPerformance;